import React from 'react';
import { useMediaQuery } from 'react-responsive';
import { FaFacebook, FaInstagram, FaLinkedin } from 'react-icons/fa';
import './Footer.css';

function Footer() {
  const year = new Date().getFullYear();
  const isDesktop = useMediaQuery({ minWidth: 601 });

  return (
    <footer className="footer">
      <div className="footer-copy">&copy;{year} SOUNDTRACK ARCHIVE. ALL RIGHTS RESERVED. A DARK SPACE PUBLISHING DIVISION</div>

      {/* show legal links on mobile, social icons on desktop */}
      {!isDesktop && (
        <div className="footer-links">
          <a href="https://www.darkspacepub.com/privacy-policy" className="footer-link">PRIVACY</a>
          <a href="https://www.darkspacepub.com/cookie-policy" className="footer-link">COOKIES</a>
          <a href="https://www.darkspacepub.com/terms" className="footer-link">TERMS</a>
        </div>
      )}

      {isDesktop && (
        <div className="footer-social">
          <a href="https://linkedin.com/soundtrackarchive" className="social-link" aria-label="LinkedIn" target="_blank" rel="noreferrer">
            <FaLinkedin className="social-icon" />
          </a>
          <a href="https://facebook.com/soundtrackarchive" className="social-link" aria-label="Facebook" target="_blank" rel="noreferrer">
            <FaFacebook className="social-icon" />
          </a>
          <a href="https://instagram.com/soundtrackarchive" className="social-link" aria-label="Instagram" target="_blank" rel="noreferrer">
            <FaInstagram className="social-icon" />
          </a>
        </div>
      )}
    </footer>
  );
}

export default Footer;
